import { render, staticRenderFns } from "./MoreAboutYourself.vue?vue&type=template&id=1221a495"
import script from "./MoreAboutYourself.vue?vue&type=script&lang=js"
export * from "./MoreAboutYourself.vue?vue&type=script&lang=js"
import style0 from "./MoreAboutYourself.vue?vue&type=style&index=0&id=1221a495&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1221a495')) {
      api.createRecord('1221a495', component.options)
    } else {
      api.reload('1221a495', component.options)
    }
    module.hot.accept("./MoreAboutYourself.vue?vue&type=template&id=1221a495", function () {
      api.rerender('1221a495', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/MoreAboutYourself/MoreAboutYourself.vue"
export default component.exports